import {Link} from '@mui/material'
import {FormFieldProps, SelectOption} from '..'

const title: FormFieldProps = {
  name: 'title',
  type: 'text',
  label: 'Title',
  required: true,
  placeholder: 'Hollywood, CA',
  help: 'Short summary (eg the location)',
}

const report: FormFieldProps = {
  name: 'report',
  type: 'textarea',
  label: 'Report',
  required: false,
  rows: 7,
  placeholder: 'Fun & sun hanging with my celebrity friends...',
  help: (
    <div>
      A little bit of commentary always helps to add some flavor. Reports are in Markdown format. For help with this format, check out this
      {' '}<Link href="https://www.markdownguide.org/cheat-sheet/">cheatsheet</Link> &
      {' '}<Link href="https://stackedit.io/app#">editor</Link>.
    </div>
  ),
}

const happened: FormFieldProps = {
  name: 'happened',
  type: 'date',
  label: 'Date',
  required: true,
  help: 'When did Trip happen?',
}

const tags: FormFieldProps = {
  name: 'tags',
  type: 'select',
  label: 'Tags',
  options: [] as SelectOption[],
  creatable: true,
  searchable: true,
  multi: true,
  placeholder: 'Select tags or define new one...',
  help: 'Tags can help with organization & filtering',
}

const cover: FormFieldProps = {
  name: 'coverId',
  type: 'select',
  label: 'Cover Foto',
  required: false,
  options: [],
}

const start: FormFieldProps = {
  name: 'start',
  type: 'date',
  label: 'Start Date',
  help: 'Happened on or after this date.',
}

const end: FormFieldProps = {
  name: 'end',
  type: 'date',
  label: 'End Date',
  help: 'Happened before this date.',
}

const filterTags: FormFieldProps = {
  name: 'tags',
  type: 'select',
  label: 'Tags',
  options: [] as SelectOption[],
  creatable: false,
  searchable: true,
  multi: true,
  placeholder: 'Filter by tag...',
  help: 'Trips with matching tags.',
}

const token: FormFieldProps = {
  name: 'token',
  type: 'text',
  label: 'Token',
  help: 'If you were given a token, you may enter it here.',
}

const prior: FormFieldProps = {
  name: 'priorId',
  type: 'select',
  label: 'Prior Trip',
  options: [] as SelectOption[],
  searchable: true,
  multi: false,
  placeholder: 'Select prior Trip...',
  help: 'Linking Trips together allows for simpler navigation.',
}

const parent: FormFieldProps = {
  name: 'parentId',
  type: 'select',
  label: 'Parent Trip',
  options: [] as SelectOption[],
  searchable: true,
  multi: false,
  placeholder: 'Select parent Trip...',
  help: 'Linking Trips together allows for simpler navigation.',
}

export const AddTripForm = {title, report, happened, tags}
export const UpdateTripForm = {title, report, happened, tags, cover, prior, parent}
export const FilterTripsForm = {start, end, tags: filterTags}
export const PublicTripForm = {token}
